export var quickLinks = [{
  heading: 'States',
  items: [{
    text: 'ACT',
    href: '/browse-sale/act/'
  }, {
    text: 'NSW',
    href: '/browse-sale/nsw/'
  }, {
    text: 'Northern Territory',
    href: '/browse-sale/nt/'
  }, {
    text: 'Queensland',
    href: '/browse-sale/qld/'
  }, {
    text: 'South Australia',
    href: '/browse-sale/sa/'
  }, {
    text: 'Tasmania',
    href: '/browse-sale/tas/'
  }, {
    text: 'Victoria',
    href: '/browse-sale/vic/'
  }, {
    text: 'Western Australia',
    href: '/browse-sale/wa/'
  }]
}, {
  heading: 'Capital Cities',
  items: [{
    text: 'Canberra real estate',
    href: '/browse-sale/act/'
  }, {
    text: 'Sydney real estate',
    href: '/browse-sale/inner-sydney-nsw/'
  }, {
    text: 'Darwin real estate',
    href: '/browse-sale/darwin-nt/'
  }, {
    text: 'Brisbane real estate',
    href: '/browse-sale/greater-brisbane-qld/'
  }, {
    text: 'Adelaide real estate',
    href: '/browse-sale/adelaide-sa/'
  }, {
    text: 'Hobart real estate',
    href: '/browse-sale/greater-hobart-tas/'
  }, {
    text: 'Melbourne real estate',
    href: '/browse-sale/greater-melbourne-vic/'
  }, {
    text: 'Perth real estate',
    href: '/browse-sale/perth-metro-wa/'
  }]
}, {
  heading: 'Capital Cities - Rentals',
  items: [{
    text: 'Canberra rental properties',
    href: '/browse-rent/act/'
  }, {
    text: 'Sydney rental properties',
    href: '/browse-rent/inner-sydney-nsw/'
  }, {
    text: 'Darwin rental properties',
    href: '/browse-rent/darwin-nt/'
  }, {
    text: 'Brisbane rental properties',
    href: '/browse-rent/greater-brisbane-qld/'
  }, {
    text: 'Adelaide rental properties',
    href: '/browse-rent/adelaide-sa/'
  }, {
    text: 'Hobart rental properties',
    href: '/browse-rent/greater-hobart-tas/'
  }, {
    text: 'Melbourne rental properties',
    href: '/browse-rent/greater-melbourne-vic/'
  }, {
    text: 'Perth rental properties',
    href: '/browse-rent/perth-metro-wa/'
  }]
}, {
  heading: 'Popular Areas',
  items: [{
    text: 'Kingston, ACT',
    href: '/sale/kingston-act-2604/'
  }, {
    text: 'Belconnen, ACT',
    href: '/sale/belconnen-act-2617/'
  }, {
    text: 'Harrison, ACT',
    href: '/sale/harrison-act-2914/'
  }, {
    text: 'Deakin, ACT',
    href: '/sale/deakin-act-2600/'
  }, {
    text: 'Kambah, ACT',
    href: '/sale/kambah-act-2902/'
  }, {
    text: 'Yarralumla, ACT',
    href: '/sale/yarralumla-act-2600/'
  }, {
    text: "O'Connor, ACT",
    href: '/sale/o-connor-act-2602/'
  }, {
    text: 'Kaleen, ACT',
    href: '/sale/kaleen-act-2617/'
  }]
}, {
  heading: 'Allhomes',
  items: [{
    text: 'Past Sales Data',
    href: '/research'
  }, {
    text: 'New Homes',
    href: '/new-homes/'
  }, {
    text: 'Find an Agent',
    href: '/agents/'
  }, {
    text: 'Digital Editions',
    href: '/ah/digital-editions'
  }]
}, {
  heading: 'More',
  items: [{
    text: 'Agency Registration',
    href: '/ah/new-agency-enquiry'
  }, {
    text: 'Community',
    href: '/community'
  }, {
    text: 'Privacy Policy',
    href: 'https://www.domain.com.au/group/privacy-policy/'
  }, {
    text: 'Conditions of Use',
    href: 'https://www.domain.com.au/group/conditions-of-use/'
  }, {
    text: 'Tracking and Targeting',
    href: 'https://www.domain.com.au/group/tracking-and-targeting/'
  }, {
    text: 'Sitemap',
    href: '/ah/act/info/site-map/view'
  }, {
    text: 'Commercial',
    href: 'https://www.commercialrealestate.com.au/'
  }]
}];